<div class="dialog-content-max">
   <p-table #dt [value]="tableData"[rows]="rows2" [scrollable]="true" scrollDirection="horizontal"
      [customSort]="true" (sortFunction)="this.utilityservice.customSort($event)"
       scrollHeight="{{commonScrollHeight}}" [globalFilterFields]="['organisation']"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"(onPage)="handlePageChange($event)"
        [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true" [showCurrentPageReport]="true"
        paginatorLocale="fa-IR" [paginator]="true"   [sortOrder]="1" responsiveLayout="scroll">
        <!-- search -->
     
        <ng-template pTemplate="caption">
          <div class="grid table-header">
            <div class="col-12 md:col-10 sm:col-12 lg:col-10">
              <span class=" p-input-icon-lft">
                <i icon="pi pi-search"></i>
                <input class="form-control" pInputText type="text" id="tablesearch"
                (input)="dt.filterGlobal($any($event.target).value , 'contains')" placeholder="Search in Training"
                  class="tablesearch" pTooltip="Enter Search Criteria" tooltipPosition="top" />
              </span>
            </div>
             <!-- <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
              <div class="iconexcel" pTooltip="Download Excel Data" tooltipPosition="bottom"
              (click)="exceldownloadModal=true"></div>
            </div> -->
          </div>
      </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <ng-container *ngFor="let col of _selectedColumns">
              <th [pSortableColumn]="col.field" *ngIf="col.isChecked">
                {{col.header}}<p-sortIcon [field]="col.field" ></p-sortIcon>
                <p-columnFilter type="text" [field]="col.field" display="menu"></p-columnFilter>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
          <tr>
            <ng-container *ngFor="let col of _selectedColumns" >
            <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class"  >
              <span pTooltip=" {{data[col.field] }}">{{data[col.field]}}</span>
            </td>
          </ng-container>
          </tr>
        </ng-template>
      </p-table>
</div>

  